import { registerComponent, getComponentConfig } from "helpers";

registerComponent(
  "show-more-button",
  class ShowMoreButton extends HTMLElement {
    DEFAULT_CONFIG = {
      parentElement: ".filters__group",
    };
    constructor() {
      super();
      this.config = getComponentConfig(this);

      const button = this.querySelector("button");
      button.addEventListener("click", (event) => {
        this.expandShowMore(event);
        const nextElementToFocus = event.target
          .closest(this.config.parentElement)
          .querySelector(".show-more-item");
        if (
          nextElementToFocus &&
          !nextElementToFocus.classList.contains("hidden") &&
          nextElementToFocus.querySelector("a, input")
        ) {
          nextElementToFocus.querySelector("a, input").focus();
        }
      });
    }

    expandShowMore(event) {
      const parentDisplay = event.target.closest(this.config.parentElement);
      this.querySelectorAll(".show-more-button__label").forEach((element) =>
        element.classList.toggle("hidden"),
      );
      parentDisplay
        .querySelectorAll(".show-more-item")
        .forEach((item) => item.classList.toggle("hidden"));
      if (!this.querySelector(".show-more-button__label--show-less")) {
        this.classList.add("hidden");
      }
    }
  },
);
